/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HubTerminalTipOptions } from './HubTerminalTipOptions';
import {
    HubTerminalTipOptionsFromJSON,
    HubTerminalTipOptionsFromJSONTyped,
    HubTerminalTipOptionsToJSON,
    HubTerminalTipOptionsToJSONTyped,
} from './HubTerminalTipOptions';

/**
 * 
 * @export
 * @interface Percentage
 */
export interface Percentage extends HubTerminalTipOptions {
    /**
     * 
     * @type {Array<number>}
     * @memberof Percentage
     */
    values: Array<number>;
}

/**
 * Check if a given object implements the Percentage interface.
 */
export function instanceOfPercentage(value: object): value is Percentage {
    if (!('values' in value) || value['values'] === undefined) return false;
    return true;
}

export function PercentageFromJSON(json: any): Percentage {
    return PercentageFromJSONTyped(json, false);
}

export function PercentageFromJSONTyped(json: any, ignoreDiscriminator: boolean): Percentage {
    if (json == null) {
        return json;
    }
    return {
        ...HubTerminalTipOptionsFromJSONTyped(json, true),
        'values': json['values'],
    };
}

export function PercentageToJSON(json: any): Percentage {
    return PercentageToJSONTyped(json, false);
}

export function PercentageToJSONTyped(value?: Percentage | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        ...HubTerminalTipOptionsToJSONTyped(value, true),
        'values': value['values'],
    };
}

